export const goToWebsite = ():void => {
    window.open('https://constell.com/', '_blank');
};
